/**
 * FoundersFocusSection — Clean text-only quote section. v2
 * Layout: Label → Quote → Author Name → Designation
 * No photo, no RichTextEditor, no decorative mark. Plain textarea only.
 */
import React from 'react';

export function FoundersFocusSection({ section, isSelected, updateSection }) {
  const data    = section.data     || {};
  const st      = section.settings || {};

  const name        = data.name        ?? 'Bertin Dcruz';
  const designation = data.designation ?? 'Founder and CEO, Electronikmedia';
  const quote       = data.quote       ?? '';
  const align       = st.textAlign     || 'left';

  const bg       = st.backgroundColor || '#e9e0cc';
  const fontCol  = st.textColor        || '#000000';
  const padding  = st.padding          || '28px 32px';

  const updateData = (patch) =>
    updateSection(section.id, { data: { ...data, ...patch } });

  return (
    <div style={{ backgroundColor: bg, padding }}>
      {/* Section label */}
      <div style={{
        fontSize: 22, fontWeight: 700, color: fontCol,
        marginBottom: 16, textAlign: align,
        fontFamily: "'Instrument Serif', serif",
      }}>
        Founder Focus
      </div>

      {/* Quote */}
      {isSelected ? (
        <textarea
          value={quote}
          onChange={(e) => updateData({ quote: e.target.value })}
          placeholder="Write the founder's quote here..."
          rows={5}
          style={{
            width: '100%', border: 'none', background: 'transparent',
            fontSize: 20, color: fontCol, lineHeight: 1.8,
            resize: 'none', outline: 'none', textAlign: align,
            fontFamily: 'inherit', boxSizing: 'border-box',
            fontStyle: 'italic',
          }}
        />
      ) : (
        <p style={{
          fontSize: 20, color: fontCol, lineHeight: 1.8,
          margin: '0 0 20px', textAlign: align,
          fontStyle: 'italic', whiteSpace: 'pre-wrap',
        }}>
          {quote
            ? `"${quote}"`
            : <em style={{ opacity: 0.45 }}>Click to add a quote…</em>
          }
        </p>
      )}

      {/* Spacer between quote and author */}
      <div style={{ marginTop: isSelected ? 16 : 0 }} />

      {/* Author name */}
      {isSelected ? (
        <input
          value={name}
          onChange={(e) => updateData({ name: e.target.value })}
          placeholder="Name"
          style={{
            display: 'block', width: '100%', border: 'none',
            background: 'transparent', outline: 'none',
            fontSize: 14, fontWeight: 700, color: fontCol,
            textAlign: align, marginBottom: 4,
            borderBottom: '1px dashed rgba(0,0,0,0.15)',
            boxSizing: 'border-box',
          }}
        />
      ) : (
        <div style={{
          fontSize: 14, fontWeight: 700, color: fontCol,
          textAlign: align, marginBottom: 2,
        }}>
          {name}
        </div>
      )}

      {/* Designation */}
      {isSelected ? (
        <input
          value={designation}
          onChange={(e) => updateData({ designation: e.target.value })}
          placeholder="Designation"
          style={{
            display: 'block', width: '100%', border: 'none',
            background: 'transparent', outline: 'none',
            fontSize: 14, color: fontCol, opacity: 0.7,
            textAlign: align,
            borderBottom: '1px dashed rgba(0,0,0,0.15)',
            boxSizing: 'border-box',
          }}
        />
      ) : (
        <div style={{
          fontSize: 14, color: fontCol, opacity: 0.7,
          textAlign: align,
        }}>
          {designation}
        </div>
      )}
    </div>
  );
}
